<ion-menu menuId="client-support-login-menu" contentId="public-main-content" type="overlay" side="end"
  class="custom-utility-menu">
  <ion-header>
    <nav-utility-bar-login [isProfileOpen]="true" class="hide-md-up"></nav-utility-bar-login>
  </ion-header>

  <ion-toolbar>
    <ion-title class="text-center">Client Support</ion-title>
  </ion-toolbar>

  <ion-content class="ion-padding">
    <div class="ion-padding-top"><template-help-menu [isLoggedIn]="isLoggedIn()"
        (closeMenu)="dismiss()"></template-help-menu></div>

    @if (isDevMode && isNative) {
      <ion-item detail button (click)="chooseEnvironment()" color="secondary">
        <ion-label class="ion-text-wrap">Choose Environment</ion-label>
      </ion-item>
    }
  </ion-content>
</ion-menu>